import React from 'react';
import { AspectRatio } from '@chakra-ui/react';

/**
 * VideoPlayer component that renders a video player with the given video source.
 * @param {Object} video - The video object containing the source URL and type.
 * @param {string} video.src - The source URL of the video.
 * @param {string} video.type - The type of the video.
 * @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video
 * @see https://web.dev/video-and-source-tags/
 */
const VideoPlayer = ({
  aspectRatio = 4 / 3,
  objectFit = 'scale-down',
  maxH = 'inherit',
  ...videoOptionsRest
}) => (
  <AspectRatio ratio={aspectRatio} height="full" maxH={maxH} maxW="full" w="full">
    <video
      controls
      controlsList="nodownload"
      autoPlay={false}
      muted
      playsInline
      {...videoOptionsRest}
      style={{ objectFit }}
    >
      <track kind="captions" />

      {/** FALLBACK */}
      <p>
        Sorry, your browser does not support embedded videos. Please update to the latest version,
        or try another browser.
      </p>
    </video>
  </AspectRatio>
);

export default VideoPlayer;
